











import { Component, Prop, Vue } from "vue-property-decorator";
import { DebugHelper } from "@/helper/debugHelper";

import * as def from "@/definitions";

@Component({
  components: {
    }
})
export default class Node extends Vue
{
    @Prop() node! : any;
    @Prop() selectedNode! : any;
    @Prop() hierarchy! : number;

    select(id){
        this.$emit("select" , id)
    }

    private get userConfigBackgroundColor(){
        var style = {};
        if(this.node.id == this.selectedNode.id){
            DebugHelper.trace(this.hierarchy);
            style = {
                position: "relative",
                display: "table",
                width: "calc(100% + " + (16 * this.hierarchy　+ 6) + "px)",
                height: "25px",
                left : -16 * this.hierarchy + "px",
                backgroundColor : this.$store.getters.userConfigColors.buttonColorRgba,
                pointerEvents: "none"
            }
        }
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }
}
